<template>
  <div class="my-pooq-content-body">
      <div class="mypooq-list"
           v-infinite-scroll="loadMore"
           :infinite-scroll-distance="200"
           :infinite-scroll-throttle-delay="200">
          <my-pooq-empty-list v-if="!isLoading && channelLikeList.length === 0" info-text="관심 채널 내역이 없어요."></my-pooq-empty-list>
          <zzim-like-info v-if="!isLoading && channelLikeList.length === 0" type="live" :toggleSubScribe="toggleSubScribe" :goPlayer="goPlayer"></zzim-like-info>
        <ul class="like-list like-channel-list">
          <!-- 좋아요 채널 리스트 -->
          <li v-for="(likeItem, index) in this.channelLikeList" :key="likeItem.title + '_' + index">
            <a href="#" @click.prevent="goPlayer(likeItem)">
              <div class="picture-area circle-img">
                <WebpImage :image-info="{imageUrl: likeItem.image, width: 176, height: 0, option: '10', alt: likeItem.channelname}"/>
              </div>
              <div class="like-title-box">
                <span class="txt-title" v-html="likeItem.channelname"></span>
              </div>
            </a>
            <button type="button" class="btn-like" @click.prevent="()=>toggleSubScribe(likeItem)">
              <LikeOn v-if="likeItem.zzim === 'y'"/>
              <LikeOff v-else/>
            </button>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { MyPooqService } from '@/common/api/api.service'
import { infiniteScroll } from '@/common/directives'
import LikeOn from '@/assets/svg/common/ic-detail-small-like-on.svg'
import LikeOff from '@/assets/svg/common/ic-detail-small-like-off.svg'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { MSG_COMPLETE_ADD_ZZIM_LIVE, MSG_COMPLETE_DELETE_ZZIM_LIVE } from '@/common/constant'
import ZzimLikeInfo from '@/components/lnb/mypooq/ZzimLikeInfo'
import utils from '@/common/util/utils'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import WebpImage from '@/components/image/WebpImage'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'MyPooqLikeChannel',
  components: {
    WebpImage,
    LikeOn,
    LikeOff,
    MyPooqEmptyList,
    ZzimLikeInfo
  },
  props: ['subMenuIndex'],
  directives: {
    infiniteScroll
  },
  data () {
    return {
      channelLikeList: [],
      offset: 0,
      limit: 20,
      endOfList: false,
      showEmptyList: false,
      isLoading: false,
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    goPlayer (channelItem) {
      if (this.device === 'mobile') {
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: {
            section: 'live'
          },
          query: { channelid: channelItem.channelid, referer: this.$route.fullPath }
        })
      } else {
        location.href = 'captvpooq://player/live?channelid=' + channelItem.channelid
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.zzim({
        offset: this.offset,
        limit: this.limit,
        contenttype: 'live'
      }).then(({ data }) => {
        const resList = get(data, ['0', 'list'], [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.channelLikeList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.channelLikeList = this.channelLikeList.concat(resList)
        this.isLoading = false
      })
    },
    toggleSubScribe (likeItem) {
      if (likeItem.zzim === 'y') {
        MyPooqService.deleteZzim({
          contenttype: 'live',
          contentids: [likeItem.channelid],
          delalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_DELETE_ZZIM_LIVE })
          this.$nextTick(() => {
            likeItem.zzim = 'n'
          })
        })
      } else {
        MyPooqService.setZzim({
          contenttype: 'live',
          contentid: likeItem.channelid,
          addalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_ADD_ZZIM_LIVE })
          this.$nextTick(() => {
            likeItem.zzim = 'y'
          })
        })
      }
    },
    getThumbnailImg (likeItem) {
      return resizeThumbnail(get(likeItem, 'image', ''), { width: 176, height: 0, option: 10 })
    }
  }
}
</script>

<style scoped>
  .like-channel img {
    width: 40px;
    height: 40px;
  }
</style>
